import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#e2ede6] text-[#0b1a2e]/70">
        <Loader2 className="w-6 h-6 animate-spin mr-3" /> Checking your session…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (roles && roles.length && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#e2ede6] text-[#0b1a2e] p-6 text-center">
        <h1 className="text-3xl font-semibold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Access restricted
        </h1>
        <p className="mt-2 text-[#0b1a2e]/70">Your role ({user.role}) doesn’t have permission for this area.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
